var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.membershipLoaded
        ? _c(
            "wiki-main-page-header",
            {
              attrs: { "show-back-button": _vm.showBackButton },
              on: {
                goToManageAccess: _vm.goToManageAccess,
                goBack: _vm.goBack,
              },
            },
            [
              _vm.isMainSectionOpened
                ? _c("span", { staticClass: "wiki-header-label" }, [
                    _vm._v(_vm._s(_vm._f("cutName")(_vm.wikiName, 30)) + " "),
                    _vm.isEditable && _vm.editMode
                      ? _c("i", {
                          staticClass: "fa fa-pencil pointer",
                          on: { click: _vm.editWiki },
                        })
                      : _vm._e(),
                  ])
                : _c("wiki-breadcrumbs", {
                    attrs: {
                      section: _vm.currentSection,
                      wikiOwner: _vm.wikiOwner,
                    },
                    on: {
                      mainSectionClick: _vm.onMainSectionOpen,
                      sectionClick: _vm.onSectionOpen,
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.readReceiptMode && _vm.membershipLoaded && _vm.membershipAccessGranted
        ? _c("wiki-read-receipt-page-navigation", {
            staticClass: "margin-15-top margin-10-bottom",
            on: {
              onSectionOpen: _vm.onSectionOpen,
              onSlideOpen: _vm.onSlideOpen,
              onMainSectionOpen: _vm.onMainSectionOpen,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("wiki-page-abstract", {
        key: _vm.wikiId,
        attrs: {
          "wiki-id": _vm.wikiId,
          "access-code": _vm.accessCode,
          getSectionLink: _vm.getSectionLink,
        },
        on: {
          onSectionOpen: _vm.onSectionOpen,
          goBack: _vm.goBack,
          onMainSectionOpen: _vm.onMainSectionOpen,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }